import React, { useMemo, useState } from "react";
import { isAuthenticated } from "../auth";
import { createImageProduct } from "../auth/apiProduct";
import ErrorAlert from "../pageInside/ErrorAlert";
import ShowimagesLoading from "./showImagesLoading";
import { language } from "../pageInside/dataElakay";
import { MdClose, MdCloudUpload, MdImage } from "react-icons/md";
import "./imagesLoading.css";
import { elakayAutoText } from "./dataElakay";


const ImagesLoading = (props) => {
  const { token } = isAuthenticated();

  const {
    infoSource,
    loadProductsView,
    productsID,
    FiltersHand = {},
    ImagesProd,
    existingCount,
    maxImgSize = 6,
    imgSize = 0
  } = props;
  // ========== PRESERVED STATE (EXACT COPY) ==========
  const [post, setPost] = useState({
    title: "",
    desc: "",
    photos: []
  });

  const [highlight, setHighlight] = useState(false);
  const [error, setError] = useState(null);

  const { photos } = post;

  // ========== PRESERVED COMPUTED VALUES (EXACT COPY) ==========
  const filterID = FiltersHand?._id || "";

  const baseCount = useMemo(() => {
    if (typeof existingCount === "number") return existingCount;
    const g = ImagesProd?.galeries;
    return Array.isArray(g) ? g.length : 0;
  }, [existingCount, ImagesProd]);

  const sizeImg = (photos?.length || 0) + (baseCount || 0);

  // ========== PRESERVED FUNCTIONS (EXACT COPY) ==========
  const imagesSeletCSS = (bytes = 0) => {
    const ok = { border: "2px solid green" };
    const big = { border: "4px solid red" };
    return bytes > 2_000_000 ? big : ok;
  };

  const handleFiles = (files) => {
    const filesArr = Array.from(files || []);
    if (filesArr.length === 0) return;

    const remaining = Math.max(0, maxImgSize - sizeImg);
    if (remaining === 0) return;

    const toRead = filesArr.slice(0, remaining);

    toRead.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.addEventListener("load", () => {
        const fileobj = {
          file,
          name: file.name,
          type: file.type,
          size: file.size,
          src: reader.result
        };

        setPost((prev) => ({
          ...prev,
          photos: [...prev.photos, fileobj]
        }));
      });
    });
  };

  const handlefilechange = (e) => handleFiles(e.target.files);

  const handledelete = (e) => {
    const target = e.target.parentElement;
    const idx = Number(target?.dataset?.imgindex);
    if (Number.isNaN(idx)) return;

    setPost((prev) => ({
      ...prev,
      photos: [...prev.photos.slice(0, idx), ...prev.photos.slice(idx + 1)]
    }));
  };

  const handlehighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(true);
  };

  const handleunhighlight = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
  };

  const handledrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setHighlight(false);
    const dt = e.dataTransfer;
    handleFiles(dt.files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!productsID) {
      setError(elakayAutoText("h_8f493c90f5d2f7", "Missing product id."));
      return;
    }
   
    if (!photos?.length) return;

    try {
      setError(null);

      for (const f of photos) {
        const data = await createImageProduct(token, filterID, productsID, f.file);
        if (data?.error) {
          setError(data.error);
          return;
        }
      }

      loadProductsView?.(productsID);
      setPost({ title: "", desc: "", photos: [] });
    } catch (err) {
      setError(err?.message || elakayAutoText("h_144debaf18c24a", "Upload failed."));
    }
  };

  // ========== RENDER (MODERN WRAPPER) ==========
  return (
    <div className="images-loading-modern">
      <div className="images-loading-container">
        {/* Header */}
        <div className="upload-header-modern">
          {filterID ? (
            <div className="header-success-modern">
              <MdImage className="header-icon-modern" />
              <h2 className="header-title-modern">
                {language(infoSource, "sellPage", "addImgNess")}
              </h2>
            </div>
          ) : (
            <div className="header-warning-modern">
              <MdImage className="header-icon-modern" />
              <h2 className="header-title-modern">
                {language(infoSource, "sellPage", "selFilAddImg")}
              </h2>
            </div>
          )}
        </div>

        {/* Form */}
        <form encType="multipart/form-data" className="upload-form-modern">
          {/* Preview Grid */}
          {photos?.length > 0 && (
            <div className="preview-grid-modern">
              {photos.map((a, i) => (
                <div
                  className="preview-item-modern"
                  key={i}
                  data-imgindex={i}
                  style={imagesSeletCSS(a.size)}
                >
                  <button
                    type="button"
                    className="preview-delete-modern"
                    onClick={handledelete}
                  >
                    <MdClose />
                  </button>
                  <ShowimagesLoading
                    className="preview-image-modern"
                    src={a.src}
                    alt={a.name}
                  />
                  <div className="preview-info-modern">
                    <span className="preview-name-modern">{a.name}</span>
                    <span className="preview-size-modern">
                      {(a.size / 1024 / 1024).toFixed(2)} MB
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Drop Zone */}
          <div className="drop-zone-wrapper-modern">
            {sizeImg < maxImgSize ? (
              <div
                className={`drop-zone-modern ${highlight ? "highlight" : ""}`}
                onDragEnter={handlehighlight}
                onDragOver={handlehighlight}
                onDragLeave={handleunhighlight}
                onDrop={handledrop}
              >
                <input
                  type="file"
                  name="photos"
                  multiple
                  id="filephotos"
                  onChange={handlefilechange}
                  accept="image/*"
                  className="drop-zone-input-modern"
                />

                <label htmlFor="filephotos" className="drop-zone-label-modern">
                  <MdCloudUpload className="drop-zone-icon-modern" />

                  <div className="drop-zone-text-modern">
                    <span className="drop-zone-title-modern">
                      {language(infoSource, "sellPage", "dragDrop")}
                    </span>
                    <span className="drop-zone-subtitle-modern">
                      {language(infoSource, "Button", "add")} {maxImgSize - sizeImg}{" "}
                      {language(infoSource, "sellPage", "morimagesnot")}
                    </span>
                  </div>

                  <div className="drop-zone-counter-modern">
                    <span className="counter-current-modern">{sizeImg}</span>
                    <span className="counter-separator-modern">/</span>
                    <span className="counter-max-modern">{maxImgSize}</span>
                    <span className="counter-label-modern">
                      {language(infoSource, "sellPage", "imagesof")}
                    </span>
                  </div>
                </label>
              </div>
            ) : (
              <div className="drop-zone-modern disabled">
                <label htmlFor="filephotos" className="drop-zone-label-modern">
                  <MdImage className="drop-zone-icon-modern disabled" />
                  <span className="drop-zone-title-modern disabled">
                    {language(infoSource, "sellPage", "canDragDrop")}
                  </span>
                </label>
              </div>
            )}
          </div>
        </form>

        {/* Error Alert */}
        <ErrorAlert error={error} setError={setError} duration={10000} />

        {/* Submit Button */}
        <div className="upload-actions-modern">
          <button
            className={`btn-upload-modern ${photos?.length > 0 ? "primary" : "disabled"}`}
            onClick={handleSubmit}
            disabled={!photos?.length}
            type="button"
          >
            <MdCloudUpload />
            {infoSource.language(infoSource, "Button", "submit")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImagesLoading;